import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlogRoutingModule } from './blog-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BlogRoutingModule
  ]
})
export class BlogModule { }

/**
 * Modal for Blog Response
 */
export class MblogResponse {
  token!: string;
  statusCode!: number;
  message!: string;
  data!: [MblogResponseData];
  totalRecords: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Blog data 
 */
export class MblogResponseData {
  id!: number
  title!: string
  products!: any
  category_id!: number
  description!: string
  description2!: string
  description3!: string
  short_description!: string
  image_url!: string
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  productList!: any
  imageList!: [MImageListModal]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}


export class MImageListModal {
  id!: number
  type!: string
  type_name!: string
  code!: any
  is_default!: boolean
  path!: string
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  totalRecords!: number
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MCategoryResponseModal {
  "statusCode": number
  "message": string
  "totalRecords": any
  "data": any = [MCategoryModal]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class MCategoryModal {
  "id": number
  "name": string
  "description": string
  "category_code": string
  "thumbnail_img": string
  "is_active": boolean
  "created_by": string
  "modified_by": string
  "created_at": string
  "modified_at": string
  "is_blog": boolean
  "type": number
  "skin_type_title": string
  "skin_concern_title": string
  "gender": number
  "totalRecords": number
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}